import { GET_RESUMEN_CIERRE_SEMANAL } from '../constants/action_types';

const initialState = { items: [], resumen: [], gastosGeneral: 0.0, arcadeCompl: 0.0, isLoading: false };

export default function (state = initialState, action) {


    switch (action.type) {
        case GET_RESUMEN_CIERRE_SEMANAL:
        
            return {
                items:[],
                resumen: [],
                gastosGeneral: 0.0,
                arcadeCompl: 0.0,
                isLoading: true
            };

        case GET_RESUMEN_CIERRE_SEMANAL + "_SUCCESS":
        
            return {
                items: action.payload.data.items,
                resumen: action.payload.data.resumen,
                observaciones: action.payload.data.observaciones,
                gastosGeneral: action.payload.data.gastosGeneral,
                arcadeCompl: action.payload.data.arcadeCompl,
                isLoading: false
            };

        default:

            return state;
    };
};